module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "accessStoreInfo",
    attrs: {
      "id": "accessStoreInfo"
    }
  }, [_c('el-row', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-col', {
    staticClass: "fl",
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.backGo()
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    attrs: {
      "span": 1
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "font-size": "25px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fl searthPart no-print",
    staticStyle: {
      "width": "19%"
    }
  }, [_c('p', {
    staticClass: "headerT"
  }, [_vm._v("物料配送信息")]), _vm._v(" "), _c('el-form', {
    ref: "returnForm",
    attrs: {
      "model": _vm.returnForm,
      "id": "test",
      "label-width": "100px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "物料配送编号:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "value": _vm.returnForm.code
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont hohofast-copy copyBtn",
    on: {
      "click": function($event) {
        return _vm.handleCopy(_vm.returnForm.code, $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物料配送类型:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.type),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "type", $$v)
      },
      expression: "returnForm.type"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "接收门店:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.shopInputName),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "shopInputName", $$v)
      },
      expression: "returnForm.shopInputName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态:"
    }
  }, [(_vm.returnForm.status == 4) ? _c('el-input', {
    attrs: {
      "disabled": true,
      "value": "已取消"
    }
  }) : (_vm.returnForm.status == 3) ? _c('el-input', {
    attrs: {
      "disabled": true,
      "value": "已收货"
    }
  }) : (_vm.returnForm.status == 2) ? _c('el-input', {
    attrs: {
      "disabled": true,
      "value": "已发货"
    }
  }) : _c('el-input', {
    attrs: {
      "disabled": true,
      "value": "在库"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "操作人:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.operatorName),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "operatorName", $$v)
      },
      expression: "returnForm.operatorName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "提交时间:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.createTime),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "createTime", $$v)
      },
      expression: "returnForm.createTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注信息:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.memo),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "memo", $$v)
      },
      expression: "returnForm.memo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "仓库类型:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "85%"
    },
    attrs: {
      "placeholder": "请选择仓库类型",
      "clearable": "",
      "disabled": !_vm.isNull(_vm.FormToWarehouseType) || _vm.returnForm.status == 3
    },
    model: {
      value: (_vm.toWarehouseType),
      callback: function($$v) {
        _vm.toWarehouseType = $$v
      },
      expression: "toWarehouseType"
    }
  }, _vm._l((_vm.warehouseList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraCode
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    staticStyle: {
      "width": "78%"
    }
  }, [_c('el-card', {
    staticClass: "box-card fr",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "table",
      "data": _vm.returnData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      },
      "summary-method": _vm.getSummaries,
      "show-summary": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "index",
      "width": "50",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialCode",
      "label": "物料编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "modelName",
      "label": "型号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "sum",
      "width": "100",
      "label": "配送数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "inboundPrice",
      "width": "100",
      "label": "配送金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.showSerialNumber(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看序列号\n            ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-content",
    attrs: {
      "visible": _vm.dialogTableVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  }, [_c('el-row', {
    staticClass: "dialog-code-content",
    attrs: {
      "element-loading-text": "拼命加载中",
      "element-loading-spinner": "el-icon-loading"
    }
  }, _vm._l((_vm.checkCodeList), function(item, index) {
    return (item != '') ? _c('el-col', {
      key: index,
      attrs: {
        "span": 6
      }
    }, [_c('p', [_vm._v(_vm._s(item))])]) : _vm._e()
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogTableVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.returnForm.shopOutDept == _vm.deptId && _vm.returnForm.status == 2),
      expression: "returnForm.shopOutDept == deptId && returnForm.status == 2"
    }],
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancelDelivery
    }
  }, [_vm._v("取消配送\n  ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.returnForm.shopInputDepe == _vm.deptId && _vm.returnForm.status == 2),
      expression: "returnForm.shopInputDepe == deptId && returnForm.status == 2"
    }],
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmRecive
    }
  }, [_vm._v("确认收货\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-09b28a1e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/storeManageOuter/materDeliveryInfo.vue
// module id = 1577
// module chunks = 0